import { MASSIVE_M } from "./types.js";

export const GET_PROCESS_STATE = `${MASSIVE_M}GET_PROCESS_STATE`;
export const GET_SELECTED_FILE = `${MASSIVE_M}GET_SELECTED_FILE`;
export const GET_UPLOAD_PROGRESS = `${MASSIVE_M}GET_UPLOAD_PROGRESS`;
export const GET_VALIDATION_RESULT = `${MASSIVE_M}GET_VALIDATION_RESULT`;
export const GET_PROCESS_RESULT = `${MASSIVE_M}GET_PROCESS_RESULT`;
export const GET_UPLOAD_DRAWER_OPEN = `${MASSIVE_M}GET_UPLOAD_DRAWER_OPEN`;
export const GET_DELETE_DRAWER_OPEN = `${MASSIVE_M}GET_DELETE_DRAWER_OPEN`;
export const GET_CURRENT_STEP = `${MASSIVE_M}GET_CURRENT_STEP`;
export const GET_ERRORS = `${MASSIVE_M}GET_ERRORS`;
